import { render, staticRenderFns } from "./BoardCardTimeUntilSchedule.vue?vue&type=template&id=0ce21451&"
import script from "./BoardCardTimeUntilSchedule.vue?vue&type=script&lang=js&"
export * from "./BoardCardTimeUntilSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports